<!-- use tags -->

import Layout1 from "../../src/routes/+layout.marko";
import Page from "../../src/routes/contact/+page.marko";

<Layout1>
	<Page/>
</>
